import { Directive, Input } from '@angular/core';

@Directive({
  selector: '[flTrackingSection]',
})
export class TrackingSectionDirective {
  @Input() flTrackingSection: string;
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-webapp-compat/webapp/src/app/@shared/tracking/tracking-section.directive.ts